import { styled } from '@mui/material';
import { useCallback } from 'react';
import { toast } from 'react-toastify';
import { FrontButton } from 'src/ui-components';
import { CopyIcon } from 'src/ui-components/icons';
import { themeVars } from 'src/ui-components/theme/theme';

export const AsinCell = ({ asin, asinLink }: { asin: string; asinLink: string }) => {
  const onCopy = useCallback(() => {
    console.log(asin);
    navigator.clipboard.writeText(asin).then(() =>
      toast('ASIN has been copied!', {
        position: 'bottom-left',
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
      }),
    );
  }, [asin]);

  return (
    <Wrapper>
      <Link href={asinLink}>{asin}</Link>
      <FrontButton isIcon variant="tertiary" size={'xs'} onClick={onCopy}>
        <CopyIcon color={themeVars.colors.titan600} />
      </FrontButton>
    </Wrapper>
  );
};

const Wrapper = styled('div')`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Link = styled('a')`
  color: #3250fa;
  font-family: ${({ theme }) => theme.fonts.telka};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;
